export const factSheetHeader = {
  labels: {
    accountNumber: 'Numéro de compte',
    orderConfirmationEmail: 'Courriel de confirmation de commande',
    mrpdProgramMedallionLevel: 'Niveau médaillon du programme MRPD',
    priceGroup: 'Groupe de prix',
    name: 'Nom',
    advanceShipNoticeEmail: "Courriel d'avis d'expédition anticipé",
    factSheet: 'Fiche de renseignements',
    address: 'Adresse',
    invoiceEmail: 'Courriel de facturation',
  },
};
export const factSheetGroup = {
  header: {
    materialGroup: 'Groupe de matériaux',
    multiplier: 'Multiplicateur',
  },
};
export const factSheetMaterial = {
  header: {
    material: 'Matériau',
    description: 'Description',
    netPrice: 'Prix net',
    currency: 'Devise',
  },
};
export const factSheet = {
  factSheetHeader,
  factSheetGroup,
  factSheetMaterial,
};
